import cx from "classnames";
import React, { Fragment, useCallback } from "react";
import styles from "./WellnessTabs.module.scss";

interface IProps {
  activeTab: string;
  onChange: (tabKey: string) => void;
  tabs: { key: string; name: string; content: string | React.ReactNode }[];
}

export default function WellnessTabs({ activeTab, onChange, tabs }: IProps) {
  const onTabChange = useCallback(
    (key: string) => () => onChange(key),
    [onChange]
  );
  return (
    <div id="wellnessTabs" data-scroll-section className={cx(styles.section)}>
      <div className={cx(styles.headingTab)}>
        {tabs.map((item, index) => (
          <Fragment key={`heading_${index}`}>
            {index !== 0 && (
              <span className={cx("mx-3", styles.pipeSymbol)}>{"|"}</span>
            )}
            <div
              className={cx(
                styles.nameTab,
                activeTab === item.key ? styles.active : styles.inactive
              )}
              onClick={onTabChange(item.key)}
            >
              {item.name}
            </div>
          </Fragment>
        ))}
      </div>
      {tabs.map((item, index) => (
        <div
          key={index}
          className={cx(
            styles.contentTab,
            activeTab === item.key ? "block" : "hidden"
          )}
        >
          {item.content}
        </div>
      ))}
    </div>
  );
}
